import { render } from "./sub-bread.vue?vue&type=template&id=0ff45c2a"
import script from "./sub-bread.vue?vue&type=script&lang=js"
export * from "./sub-bread.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__